import React, { useState, useEffect } from 'react';
import Fireworks from '../assets/fireworks.mp4';
import TagManager from 'react-gtm-module';
import Navbar from '../pages/Register/Navbar';
import Footer from '../pages/Register/Footer';
import { useRTL } from '../hooks/useRTL';
import { useTranslation } from 'react-i18next';
import Support from '../components/Support';
import { useNavigate } from 'react-router-dom';

const Business = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const gtmId = 'GTM-T4QRDGLB';
  const isRTL = useRTL();
  const navigate = useNavigate();

  const initializeTagManager = () => {
    TagManager.initialize({ gtmId });
  };

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  }, [isRTL]);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);
    initializeTagManager();
    setIsMobile(isIOS || isAndroid);
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Support />
      <div
        className={`flex min-h-screen flex-col ${isRTL ? 'rtl' : 'ltr'}`}
        dir={isRTL ? 'rtl' : 'ltr'}>
        <Navbar isRegisterPage={true} Translated={true} />

        <main className='flex-grow flex flex-col items-center justify-center mb-8'>
          <div className='flex flex-col items-center text-center px-4'>
            <video
              playsInline
              autoPlay
              muted
              loop
              className='w-[400px] max-w-full object-contain'>
              <source src={Fireworks} type='video/mp4' />
            </video>

            <h1 className="font-['Hurme-Bold'] text-booker px-2.5 mt-6 text-3xl">
              {t('thanksBusiness.IntroKey')}
            </h1>

            <p className="font-['Hurme-Light'] mt-2.5 px-2.5">
              {t('thanksBusiness.ThankYou')}
              <br />
              {isMobile && (
                <span className="font-['Hurme-Light'] mt-2.5 block text-lg">
                  {t('thanksBusiness.ThankYouMobile')}
                </span>
              )}
            </p>

            <div
              onClick={() => navigate('/')}
              className="bg-booker text-white flex justify-center items-center px-6 py-2 font-['Hurme-Bold'] rounded-[20px] cursor-pointer mt-6 min-w-[120px] mx-auto">
              {isMobile
                ? t('thanksBusiness.DiveNow')
                : t('thanksBusiness.BackToWebsite')}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Business;
